import React  from 'react';

const Logo = () => (
    <img src="logo.png" alt="logo" width={200} />
);

export default Logo;
